var map = {
	"./1-teaser.webp": 50321,
	"./2-book.jpg": 15539,
	"./3-poem.jpg": 64842,
	"./4-infograph.jpg": 82636,
	"./intro-1.webp": 57105,
	"./intro-2.webp": 78996,
	"./intro-3.webp": 63703,
	"./intro-4.webp": 25178,
	"./intro-5.webp": 39205,
	"./intro-6.webp": 83928,
	"./visap-preview-music.mp4": 86356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50835;